module.exports = __webpack_public_path__ + "assets/img/DS-room3 (4).cd81b0db.jpg";